import { Component, OnInit, ViewChild, ElementRef, Renderer, Input, AfterViewInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as jsPDF from 'jspdf';
import { ConfiguracionesService } from '../../../services/configuraciones.service';
import { Helper } from '../../../helpers/helper';
declare const CKEDITOR: any;
declare const $: any;

@Component({
  selector: 'app-carta-saldo-modal',
  templateUrl: './carta-saldo.component.html',
  styleUrls: ['./carta-saldo.component.css']
})
export class CartaSaldoModalComponent implements OnInit, AfterViewInit {
  @ViewChild('pdf') pdf: ElementRef;
  @ViewChild('bodyPdf') bodyPdf: ElementRef;
  @ViewChild('headerPdf') headerPdf: ElementRef;
  @ViewChild('footerPdf') footerPdf: ElementRef;
  @Input() datos: any;
  commands = [];
  exportando = false;
  doc: any = new jsPDF('p', 'pt', 'letter');
  pageWidth: number = this.doc.internal.pageSize.getWidth();
  pageHeight: number = this.doc.internal.pageSize.getHeight();
  imgFooter: string;
  pdfContent: string;
  date = new Date(this.helper.getDate());
  isEditing = false;
  templateCarta = {
    direccion: '',
    cel: '',
    tel: '',
    empresa: ''
  };

  ckeditorHasErrror = false;
  ckeditor: string;
  // tslint:disable-next-line:max-line-length
  constructor(public activeModal: NgbActiveModal, private render: Renderer, private configuracionesService: ConfiguracionesService, private helper: Helper) {
    this.imgFooter = './assets/img/carta-footer.png';
    this.modeloCarta();
  }

  ngOnInit() {
  }

  private initCarta() {

    this.ckeditor = this.pdfContent;
    this.restoreCkeditorContent();
    // const maxHeight = (this.pageHeight * 60) / 100;
    const maxHeight = 792 - this.headerPdf.nativeElement.offsetHeight - this.footerPdf.nativeElement.offsetHeight;
    this.render.setElementStyle(this.pdf.nativeElement, 'height', `${this.pageHeight}pt`);
    this.render.setElementStyle(this.pdf.nativeElement, 'width', `${this.pageWidth}pt`);
    this.render.setElementStyle(this.bodyPdf.nativeElement, 'max-height', `${maxHeight}pt`);
    this.render.setElementStyle(this.bodyPdf.nativeElement, 'overflow', 'hidden');
    this.render.setElementStyle(this.bodyPdf.nativeElement, 'padding-right', '-10px');

    // Styles for footer pdf
    this.render.setElementStyle(this.footerPdf.nativeElement, 'padding', '0 2rem 3rem 2rem');
    this.render.setElementStyle(this.footerPdf.nativeElement, 'background-image', `url(${this.imgFooter})`);
    this.render.setElementStyle(this.footerPdf.nativeElement, 'background-repeat', 'no-repeat');
    this.render.setElementStyle(this.footerPdf.nativeElement, 'background-size', 'cover');
    this.initCkeditor();
  }

  private modeloCarta(): void {
    this.configuracionesService.modeloCartaSaldo()
    .subscribe((res: any) => {
      this.templateCarta.direccion = res.direccion;
      this.templateCarta.tel = res.telefono;
      this.templateCarta.cel = res.celular;
      this.pdfContent = res.modelo_html;
      this.templateCarta.empresa = res.empresa;
      this.initCarta();
    });
  }

  printCarta() {
    this.exportando = true;

    setTimeout(() => {

      const pdfName = `carta de saldo de ${this.datos.nombre + '  ' + this.datos.apellido}.pdf`.toLowerCase();
      this.helper.exportarCartaPdf(pdfName, this.pdf, this.doc)
      .then(() => {
        this.exportando = false;
      });
    }, 0);
  }

  private initCkeditor() {
    CKEDITOR.replace('editor1', {
      height: 600,
      on: {
        change: () => this.ckeditorHasErrror = false
      }
    });

  }

  guardarCarta() {
    const ckeditorValue = CKEDITOR.instances.editor1.getData();
    if (!ckeditorValue) {
      this.ckeditorHasErrror = true;
      return false;
    }
    this.pdfContent = ckeditorValue;
    this.restoreCkeditorContent();
    this.isEditing = false;
  }

  private restoreCkeditorContent() {
    console.log(this.datos);
    let regExp = new RegExp(`#cliente#`, 'g');
    this.pdfContent = this.pdfContent.replace(regExp, this.datos.nombre + ' ' + this.datos.apellido);

    regExp = new RegExp(`#identificacionCliente#`, 'g');
    this.pdfContent = this.pdfContent.replace(regExp, this.datos.cedula);

    regExp = new RegExp(`#empresa#`, 'g');
    this.pdfContent = this.pdfContent.replace(regExp, this.templateCarta.empresa);

    regExp = new RegExp(`#fechaSaldo#`, 'g');
    let date = new Date(this.datos.ultimo_prestamo.fecha_saldo);
    const fechaSaldo = `${date.getDate()} días del mes de ${this.helper.fullMonthNames[date.getMonth()]} del año ${date.getFullYear()}`;
    this.pdfContent = this.pdfContent.replace(regExp, fechaSaldo);

    regExp = new RegExp(`#numeroPrestamo#`, 'g');
    this.pdfContent = this.pdfContent.replace(regExp, this.datos.ultimo_prestamo.ID_PRESTAMO);

    regExp = new RegExp(`#fechaPrestamo#`, 'g');
     date = new Date(this.datos.ultimo_prestamo.fecha_prestamo);
    const fechaPrestamo = `${date.getDate()} días del mes de ${this.helper.fullMonthNames[date.getMonth()]} del año ${date.getFullYear()}`;
    this.pdfContent = this.pdfContent.replace(regExp, fechaPrestamo);
  }

  fullScreen() {
    const modalRef = $('.modal-dialog');
    if (modalRef.hasClass('full-screen')) {
      modalRef.removeClass('full-screen');
    } else {
      modalRef.addClass('full-screen');
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.fullScreen();
    }, 0);
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/carta-saldo/carta-saldo.component.ts